@if (dialogState$ | async; as dialogState) {
  <sm-confirmation-dialog
    [isOpen]="dialogState.isOpen"
    [title]="dialogState.title"
    [description]="dialogState.description"
    [confirmationText]="dialogState.confirmationText"
    [confirmationPrompt]="dialogState.confirmationPrompt"
    [confirmationPlaceholder]="dialogState.confirmationPlaceholder"
    [confirmationMismatchLabel]="dialogState.confirmationMismatchLabel"
    [textInputLabel]="dialogState.textInputLabel"
    [textInputPlaceholder]="dialogState.textInputPlaceholder"
    [textInputInputMode]="dialogState.textInputInputMode"
    [textInputRequired]="dialogState.textInputRequired"
    [textInputMultiline]="dialogState.textInputMultiline"
    [cancelLabel]="dialogState.cancelLabel"
    [alternateLabel]="dialogState.alternateLabel"
    [confirmLabel]="dialogState.confirmLabel"
    [closeLabel]="dialogState.closeLabel"
    [busy]="dialogState.busy"
    [confirmTone]="dialogState.confirmTone"
    [contentAlign]="dialogState.contentAlign"
    [actionsAlign]="dialogState.actionsAlign"
    [compactActions]="dialogState.compactActions"
    [panelVariant]="dialogState.panelVariant"
    [expandToViewport]="dialogState.expandToViewport"
    [error]="dialogState.error"
    [dialogType]="dialogState.dialogType"
    [heroIconName]="dialogState.heroIconName"
    [showCloseButton]="dialogState.showCloseButton"
    [showCancelButton]="dialogState.showCancelButton"
    [showAlternateButton]="dialogState.showAlternateButton"
    [showConfirmButton]="dialogState.showConfirmButton"
    (cancelRequest)="handleCancel()"
    (alternateRequest)="handleAlternate()"
    (confirmRequest)="handleConfirm($event)">
    @if (dialogState.bodyTemplate) { <ng-container [ngTemplateOutlet]="dialogState.bodyTemplate" /> }
    @if (dialogState.bodyBlocks.length) {
      <div
        class="sm-confirmation-dialog-host__copy"
        [style.max-width]="dialogState.panelVariant === 'wide' ? '29rem' : null">
        @for (block of dialogState.bodyBlocks; track $index) {
          <p
            class="sm-confirmation-dialog-host__paragraph"
            [class.is-danger]="block.tone === 'danger'"
            [style.max-width]="dialogState.panelVariant === 'wide' ? '29rem' : null">
            @for (segment of block.segments; track $index) {
              @if (segment.route && segment.confirmAction) {
                <a [href]="segment.route" [attr.aria-disabled]="dialogState.busy ? 'true' : null" (click)="handleConfirmLink($event)">
                  @if (segment.emphasis) { <strong>{{ segment.text }}</strong> } @else { {{ segment.text }} }
                </a>
              } @else if (segment.route) {
                <a [routerLink]="segment.route" [queryParams]="segment.queryParams" (click)="handleCancel()">
                  @if (segment.emphasis) { <strong>{{ segment.text }}</strong> } @else { {{ segment.text }} }
                </a>
              } @else if (segment.emphasis) {
                <strong>{{ segment.text }}</strong>
              } @else {
                <span>{{ segment.text }}</span>
              }
            }
          </p>
        }
      </div>
    }
  </sm-confirmation-dialog>
}
